<template>
    <div>
       <div v-if="!logged_in" class="account-container"> 
            <div class='phone-icon' @click='headerClick("contact")'><i class="fa-solid fa-phone"></i></div>
            <button class='header-button login' @click='checkUserLoggedIn'><i class="fa-regular fa-cart-shopping header-button-icon"></i>{{ login_text }}</button>
            <button class='header-button'  @click='headerClick("new_customer")'><i class="fa-regular fa-arrow-right header-button-icon"></i>New Customer</button>
       </div>
       <div v-if="logged_in"> 
            <div v-if="screen_width >= 768" class='account' @click='checkUserLoggedIn'>{{ login_text }}</div>
            <div class='account-icon' v-if="screen_width < 768"  @click='checkUserLoggedIn'><i class="fa-solid fa-user"></i></div>
       </div>
    </div>
</template>

<script>
import {checkAuth} from "@/global/modules/functions.js";

export default {
    props: ['logged_in', 'screen_width'],
    data() {
        return {
            login_text: 'Login & Order',
        }
    },
    methods:{
        async checkUserLoggedIn(){
            let response = await fetch(`/api/user/check-logged-in`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){

                if(!results){
                    this.$router.push("/login");
                }
                else{
                    this.$router.push("/account");
                }
            }
        },
        headerClick(type){
            if(type == 'login'){
                window.location.href = "https://commercialonlineorders.majestic.co.uk/";
            }
            if(type == 'new_customer'){
                this.$router.push('/how-does-it-work/new-customer');
            }
            if(type == 'contact'){
                this.$router.push('/how-does-it-work/contact-us');
            }
        }
    },
    watch:{
        'logged_in': function(){
            // if(this.logged_in) {
            //     this.login_text = 'My Account';
            // } else{
            //     this.login_text = 'Login & Order';
            // }
            this.login_text = (this.logged_in) ? 'My Account' : 'Login & Order';
        }
    }
}
</script>

<style lang="scss" scoped>
.account-container{
    display: flex;
    gap: 22px;
    align-items: center;
    justify-content: flex-end;
}
.account{
    cursor: pointer;
    font-size: 0.93rem;

    @media(max-width:1256px){
        white-space: nowrap;
    }
}

.account-icon{
    font-size: 1.2rem;
    cursor: pointer;
}
.header-button{
    padding: 12px;
    border-radius: 8px;
    background-color: white;
    border: 1px solid gray;
    outline: none;
    cursor: pointer;

    @media(max-width: 1100px){
        display: none;
    }
}

.header-button.login{
    background-color: #184A2E;
    color: white;

}
.header-button-icon{
    margin-right: 4px;
}

.phone-icon{
    color: var(--maj-slate);
    cursor: pointer;
    margin-right: 24px;
    
    // @media(min-width: 768px){
    //     display: none;
    // }
}
</style>